import { useEffect, useState } from 'react';
// @mui
import {
  CircularProgress,
  Grid,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TablePagination,
  TableRow,
  Typography,
} from '@mui/material';
// components
import Scrollbar from '../../components/scrollbar';
// sections
import { useNavigate, useParams } from 'react-router-dom';
import { GetClient, GetInvoicesList, GetReport } from 'src/components/services/httpServices';
import InvoicesListHead from 'src/sections/@dashboard/Invoices/InvoicesListHead';
import { financial } from 'src/utils/formatNumber';
import { UserListToolbar } from '../../sections/@dashboard/user';

// ----------------------------------------------------------------------

const TABLE_HEAD = [
  { id: 'srNo', label: 'Sr#', alignRight: false },
  //{ id: 'NumAtCard', label: 'Reg Number', alignRight: false },
  //{ id: 'docEntry', label: 'Doc Entry', alignRight: false },
  { id: 'docNum', label: 'Doc Num', alignRight: false },
  { id: 'cardName', label: 'Client Name', alignRight: false },
  { id: 'docTotal', label: 'Invoice Total', alignRight: false },
  { id: 'balance', label: 'Balance', alignRight: false },
  { id: 'paidToDate', label: 'PaidToDate', alignRight: false },
  { id: 'u_branch', label: 'Branch', alignRight: false },
  { id: 'slpName', label: 'Sales Person', alignRight: false },
  { id: 'u_Executive', label: 'Executive', alignRight: false },
  { id: 'u_Referral', label: 'Referral', alignRight: false },
  //{ id: 'itemCode', label: 'Item Code', alignRight: false },
  //{ id: 'project', label: 'Project', alignRight: false },
  //{ id: 'dscription', label: 'Unit', alignRight: false },
];

// ----------------------------------------------------------------------

// ----------------------------------------------------------------------

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

function applySortFilter(array, comparator, query) {
  const stabilizedThis = array.map((el, index) => [el, index]);
  stabilizedThis.sort((a, b) => {
    const order = comparator(a[0], b[0]);
    if (order !== 0) return order;
    return a[1] - b[1];
  });
  if (query) {
    let sorted = [];
    sorted = array
      .map((_customer) => {
        const fullNameMatch = _customer?.fullName?.toLowerCase().indexOf(query.toLowerCase()) !== -1;
        const dateOfBirthMatch = _user?.dateOfBirth ? _user?.dateOfBirth?.includes(query) : false;
        const phoneNumberMatch = _user?.phoneNumber ? _user?.phoneNumber?.includes(query) : false;
        const emailMatch = _user?.email ? _user?.email?.toLowerCase().includes(query.toLowerCase()) : false;
        const uciNumberMatch = _user?.ucinumber ? _user?.ucinumber?.toLowerCase().includes(query.toLowerCase()) : false;
        const fileNumberMatch = _user?.fileNumber
          ? _user?.fileNumber?.toLowerCase().includes(query.toLowerCase())
          : false;
        const passportNoMatch = _user?.passportNo
          ? _user?.passportNo?.toLowerCase().includes(query.toLowerCase())
          : false;

        // Assign weights based on matching criteria
        const weights = {
          fullName: fullNameMatch ? 6 : 0,
          dateOfBirth: dateOfBirthMatch ? 5 : 0,
          phoneNumber: phoneNumberMatch ? 4 : 0,
          email: emailMatch ? 3 : 0,
          uciNumber: uciNumberMatch ? 2 : 0,
          passportNo: passportNoMatch ? 1 : 0,
          fileNumber: fileNumberMatch ? 1 : 0,
        };

        // Calculate total weight
        const totalWeight = Object.values(weights).reduce((sum, weight) => sum + weight, 0);

        return { user: _user, totalWeight };
      })
      .filter((obj) => obj.totalWeight > 0)
      .sort((a, b) => b.totalWeight - a.totalWeight)
      .map((obj) => obj.user);

    return sorted;
  }
  return stabilizedThis.map((el) => el[0]);
}

export default function InvoicesList(props) {
  let { id } = useParams();

  const [page, setPage] = useState(0);

  const [order, setOrder] = useState('desc');

  const [selected, setSelected] = useState([]);

  const [orderBy, setOrderBy] = useState('id');

  const [filterName, setFilterName] = useState('');

  const [rowsPerPage, setRowsPerPage] = useState(25);

  const [INVOICESLIST, setInvoicesList] = useState([]);

  const [selectedRow, setSelectedRow] = useState(null);
  const [client, setClient] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetch = async () => {
      setLoading(true);
      const savedClient = await GetClient(id);
      const response = await GetInvoicesList(savedClient?.cardCode);
      console.log('response', response);
      if (response !== null) {
        setInvoicesList(response);
        setClient(savedClient);
        setLoading(false);
        //  console.log('After');
      }
    };
    fetch();
  }, []);
  const rowClicked = async (row) => {
    setSelectedRow(row);
  };
  const rowClickedHandle = async (row) => {
    // navigate(`/app/ClientTabs/${row.id}/${true}`);
    getReport(row.docEntry);
  };

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  const handleSelectAllClick = (event) => {
    if (event.target.checked) {
      const newSelecteds = INVOICESLIST.map((n) => n.id);
      setSelected(newSelecteds);
      return;
    }
    setSelected([]);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setPage(0);
    setRowsPerPage(parseInt(event.target.value, 10));
  };

  const handleFilterByName = (event) => {
    setPage(0);
    setFilterName(event.target.value);
  };

  const emptyRows = page > 0 ? Math.max(0, (1 + page) * rowsPerPage - INVOICESLIST.length) : 0;

  const filteredUsers = applySortFilter(INVOICESLIST, getComparator(order, orderBy), filterName);

  const isNotFound = !filteredUsers.length && !!filterName;

  const style = { height: 53 * emptyRows };

  const getReport = async (row) => {
    setLoading(true);
    var payload = {
      reportName: 'Invoice',
      params: [{ parameter: 'param', value: row.docEntry }],
    };
    console.log(payload);

    let response = await GetReport(row.docEntry, payload);
    console.log('PostResponse:', response);

    if (response?.status == 200) {
      const url = window.URL.createObjectURL(response?.data);
      // const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
      const link = document.createElement('a');
      link.href = url;
      link.target = '_blank';
      // link.setAttribute('download', report+'.pdf'); //or any other extension
      document.body.appendChild(link);
      link.click();
      props.setMessage('Success');
      props.setSaved(true);
      props.setOpen(true);
      setLoading(false);
    } else {
      //   console.log('500');
      props.setMessage(response?.data);
      props.setSaved(false);
      props.setOpen(true);
      setLoading(false);
      setPosting(false);
    }
  };

  return (
    <>
      {loading ? (
        <Grid display="flex" alignItems="center" justifyContent="center" height="40vh" container>
          <CircularProgress size={60} thickness={3} value={100} />
        </Grid>
      ) : (
        <>
          <UserListToolbar
            numSelected={selected.length}
            selectedUsers={selected}
            setSelected={setSelected}
            filterName={filterName}
            onFilterName={handleFilterByName}
            //deleteUsers={deleteClientsList}
          />

          <Scrollbar>
            <TableContainer sx={{ minWidth: 800 }}>
              <Table>
                <InvoicesListHead
                  order={order}
                  orderBy={orderBy}
                  headLabel={TABLE_HEAD}
                  rowCount={INVOICESLIST.length}
                  numSelected={selected.length}
                  onRequestSort={handleRequestSort}
                  onSelectAllClick={handleSelectAllClick}
                />
                <TableBody>
                  {filteredUsers.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row, index) => {
                    const {
                      id,
                      docEntry,
                      itemCode,
                      project,
                      cardName,
                      u_branch,
                      slpName,
                      u_Referral,
                      u_Executive,
                      docNum,
                      balance,
                      paidToDate,
                      docTotal,
                      dscription,
                      numAtCard,
                    } = row;
                    const selectedCompany = selected.indexOf(id) !== -1;

                    return (
                      <TableRow
                        hover
                        key={id}
                        tabIndex={-1}
                        role="checkbox"
                        selected={selectedCompany}
                        onClick={() => rowClicked(row)}
                      >
                        <TableCell onClick={() => getReport(row)} component="th" scope="row" align="left">
                          {index + 1}
                        </TableCell>

                        <TableCell onClick={() => getReport(row)} component="th" scope="row" align="left">
                          {docNum}
                        </TableCell>
                        <TableCell onClick={() => getReport(row)} component="th" scope="row" align="left">
                          {cardName}
                        </TableCell>
                        <TableCell onClick={() => getReport(row)} align="left">
                          {financial(docTotal, 2)}
                        </TableCell>

                        <TableCell onClick={() => getReport(row)} align="left">
                          {financial(balance, 2)}
                        </TableCell>
                        <TableCell onClick={() => getReport(row)} align="left">
                          {financial(paidToDate, 2)}
                        </TableCell>

                        <TableCell onClick={() => getReport(row)} align="left">
                          {u_branch}
                        </TableCell>
                        <TableCell onClick={() => getReport(row)} align="left">
                          {slpName}
                        </TableCell>
                        <TableCell onClick={() => getReport(row)} align="left">
                          {u_Executive}
                        </TableCell>
                        <TableCell onClick={() => getReport(row)} align="left">
                          {u_Referral}
                        </TableCell>
                      </TableRow>
                    );
                  })}
                  {emptyRows > 0 && (
                    <TableRow style={style}>
                      <TableCell colSpan={6} />
                    </TableRow>
                  )}
                </TableBody>

                {isNotFound && (
                  <TableBody>
                    <TableRow>
                      <TableCell align="center" colSpan={6} sx={{ py: 3 }}>
                        <Paper
                          sx={{
                            textAlign: 'center',
                          }}
                        >
                          <Typography variant="h6" paragraph>
                            Not found
                          </Typography>

                          <Typography variant="body2">
                            No results found for &nbsp;
                            <strong>&quot;{filterName}&quot;</strong>.
                            <br /> Try checking for typos or using complete words.
                          </Typography>
                        </Paper>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                )}
              </Table>
            </TableContainer>
          </Scrollbar>

          <TablePagination
            rowsPerPageOptions={[25, 50, 100, 500]}
            component="div"
            count={INVOICESLIST.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </>
      )}
    </>
  );
}
